import React from 'react';

import { observer } from 'mobx-react';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './WhatsNewModal.module.scss';
import { useWhatsNewContent } from './hooks/useWhatsNewContent';
import { LbModal } from '../../../../shared/components/modals';
import { ModalTitle } from './ModalTitle/ModalTitle';
import { ScrollBox, MarkdownViewer } from '../../../../shared/components/ui-components';

type WhatsNewModalProps = {
  onClose: () => void;
};

const WhatsNewModal = observer(({ onClose }: WhatsNewModalProps) => {
  const { content } = useWhatsNewContent();

  const isOpen = !!(content?.items || content?.videoUrl);

  return (
    <LbModal
      open={isOpen}
      title={<ModalTitle />}
      secondaryBtnConfig={{
        onClick: onClose,
        text: 'Close',
      }}
      onClose={onClose}
    >
      <div className={classes.contentContainer}>
        {content?.videoUrl && (
          <iframe
            className={classes.video}
            title="Whats New Video"
            src={content.videoUrl}
            allowFullScreen
          />
        )}
        <ScrollBox maxHeight={400} variant="outBox">
          <div className={classes.textItems}>
            {content?.items?.map((item, index) => (
              <TitleWithDescription
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                title={item.title}
                description={<MarkdownViewer content={item.description} />}
              />
            ))}
          </div>
        </ScrollBox>
      </div>
    </LbModal>
  );
});

export { WhatsNewModal };
